import { HudRing } from "@/components/HudRing";

const fmtUptime = (s) => {
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  return d ? `${d}d ${h}h` : h ? `${h}h ${m}m` : `${m}m ${s % 60}s`;
};

const Tile = ({ k, label, value, testId }) => (
  <div className="border-b border-r border-border p-5" data-testid={testId}>
    <div className="font-mono text-[10px] text-[color:var(--au-green)]">[{k}]</div>
    <div className="mt-3 font-mono text-3xl font-semibold tabular-nums">{value}</div>
    <div className="mono-label mt-1">{label}</div>
  </div>
);

export const MetricsHud = ({ m }) => {
  if (!m) return <div className="holo-panel h-64 animate-pulse" />;
  const health = Math.max(0, 1 - (m.db_latency_ms / 200) - (m.avg_pipeline_ms > 3000 ? 0.2 : 0));
  return (
    <div className="space-y-8">
      <div className="holo-panel corners matrix-edge grid grid-cols-2 gap-8 p-8 md:grid-cols-4" data-testid="admin-status-rings">
        <HudRing value={health} display={`${Math.round(health * 100)}%`} label="System health" testId="ring-health" />
        <HudRing value={Math.min(1, m.active_rooms / 10)} display={m.active_rooms} label="Active rooms" color="var(--au-cyan)" testId="ring-rooms" />
        <HudRing value={Math.min(1, m.online_connections / 20)} display={m.online_connections} label="Live links" color="var(--au-violet)" testId="ring-online" />
        <HudRing value={m.avg_pipeline_ms ? Math.max(0.05, 1 - m.avg_pipeline_ms / 5000) : 0} display={m.avg_pipeline_ms ? `${(m.avg_pipeline_ms / 1000).toFixed(1)}s` : "—"} label="AI pipeline" color="var(--au-magenta)" testId="ring-latency" />
      </div>
      <div className="holo-panel grid grid-cols-2 border-l border-t border-border md:grid-cols-3 lg:grid-cols-6" data-testid="admin-global-metrics">
        <Tile k="01" label="Users" value={m.total_users} testId="metric-users" />
        <Tile k="02" label="Total calls" value={m.total_calls} testId="metric-calls" />
        <Tile k="03" label="Messages" value={m.total_messages} testId="metric-messages" />
        <Tile k="04" label="Languages used" value={m.languages.length} testId="metric-languages" />
        <Tile k="05" label="Minutes · 14d" value={m.minutes_14d} testId="metric-minutes" />
        <Tile k="06" label="Uptime" value={fmtUptime(m.uptime_seconds)} testId="metric-uptime" />
      </div>
    </div>
  );
};
